import RestaurantRecs from './RestaurantRecs';
export default RestaurantRecs;
